import { Injectable } from '@angular/core';
import { Cartao } from '@tivic-team/manager-ts/dist/mob/entities/cartao.entity';
import { HttpGet, HttpResponse, Quark, Url } from 'sol-request-angular/dist/comunicacao';
import { IFilter } from 'sol-request-angular/dist/comunicacao/interfaces/IFilter';
import { environment } from 'src/environments/environment';
import { ApiController } from '../api-controller.interface';
import { environmentv3 } from './../../../environments/environmentv3';

@Injectable()
export class CartaoController implements ApiController<Cartao> {

	constructor() { }
	async find(filtros?: IFilter): Promise<Cartao[]> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoesdocumentos/atendente',
					environment: environmentv3,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<Cartao>()
				)
		);
		return await quark.call();
	}
	get(...args: number[]): Promise<Cartao> {
		throw new Error('Method not implemented.');
	}
	create(entity: Cartao): Promise<Cartao> {
		throw new Error('Method not implemented.');
	}
	update(entity: Cartao): Promise<Cartao> {
		throw new Error('Method not implemented.');
	}

    async findCartoes(filtros?: IFilter): Promise<Array<Cartao>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoes/find',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<Cartao>()
			)
		);
		return await quark.call();
	}

    async findCartao(filtros?: IFilter): Promise<Array<Cartao>> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoes/findcartoes',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
				new Array<Cartao>()
			)
		);
		return await quark.call();
	}

    async generateReport(filtros?: IFilter): Promise<Blob> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoes/relatorio/cartoes',
					environment: environment,
					filter: filtros
				}),
				responseType: 'Blob'
			}),
			new HttpResponse(
				new Blob())
				);
				return await quark.call();
			}

    async gerarRelatorio(filtros?: IFilter): Promise<Blob> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoes/cartoesrelatorio',
					environment: environment,
					filter: filtros
				}),
				responseType: 'Blob'
			}),
			new HttpResponse(
				new Blob())
				);
				return await quark.call();
			}

	async getEstatistica(filtros:IFilter):Promise<any>{		

		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoes/estatisticas',
					environment: environment,
					filter: filtros
				}),
			}),
			new HttpResponse(
			  new Array<any>()
			)
		);
		return await quark.call();
	}

	async relatorio(filtros?: IFilter): Promise<Blob> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoesdocumentos/relatorio',
					environment: environment,
					filter: filtros
				}),
				responseType: 'Blob'
			}),
			new HttpResponse(
				new Blob())
				);
				return await quark.call();
			}
			
	async relatorioCids(filtros?: IFilter): Promise<Blob> {
		let quark = new Quark(
			new HttpGet({
				url: new Url({
					id: 'mob/cartoesdocumentos/relatorioquantitativocid',
					environment: environmentv3,
					filter: filtros
				}),
				responseType: 'blob'
			}),
		new HttpResponse(new Blob()));
		return await quark.call();
	}

	async relatorioProcessoAnual(filtros?: IFilter): Promise<Blob> {
        let quark = new Quark(
            new HttpGet({
                url: new Url({
                    id: 'mob/cartoesdocumentos/relatorioprocessos',
                    environment: environmentv3,
                    filter: filtros
                }),
				responseType: 'blob'
            }),
            new HttpResponse(
               new Blob()
            )
        );
        return await quark.call()
    }


}